<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Novo Profissional</h4>
      </div>
      <div class="card-body">
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <div class="row">
              <div class="col-md-2">
                <label for="nome">ID</label>
                <input id="id" type="text" class="form-control" v-model="state.profissional.id" readonly />
              </div>
              <div class="col-md-4">
                <label for="nome">Nome</label>
                <input id="nome" type="text" class="form-control" placeholder="Digite um nome:"
                  v-model="state.profissional.nome.value" />
                <span v-if="state.profissional.nome.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="endereco">Especialidade</label>
                <select class="form-select" v-model="state.profissional.especialidade_id.value"
                  @change="fetchEspecialidade($event.target.value)">
                  <option :value="especialidade.id" v-for="especialidade in state.especialidades"
                    :key="especialidade.id">
                    {{ especialidade.nome }}
                  </option>
                </select>
                <span v-if="state.profissional.especialidade_id.error" class="text-danger">Este campo é
                  obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="valor">Valor da Consulta</label>
                <input id="valor" type="text" class="form-control" placeholder="Digite um valor:"
                  v-model="state.profissional.valor_consulta.value" v-mask-decimal.br="2" />
                <span v-if="state.profissional.valor_consulta.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="valor">Destaque</label>
                <select class="form-select" v-model="state.profissional.destaque">
                  <option value="SIM">Sim</option>
                  <option value="NAO">Não</option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="telefone">Telefone</label>
                <input id="telefone" type="text" class="form-control" placeholder="Digite um telefone:" v-mask-phone.br
                  v-model="state.profissional.telefone.value" />
                <span v-if="state.profissional.telefone.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-3">
                <label for="conselho">Conselho</label>
                <input id="conselho" type="text" class="form-control" placeholder="Digite o conselho do profissional:"
                  v-model="state.profissional.conselho.value" />
                <span v-if="state.profissional.conselho.error" class="text-danger">Este campo é obrigatório</span>
              </div>

              <div class="col-md-3">
                <label for="email">E-mail</label>
                <input id="email" type="text" class="form-control" placeholder="Digite o e-mail:"
                  v-model="state.profissional.email.value" />
                <span v-if="state.profissional.email.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="cpf">CPF</label>
                <input id="cpf" type="text" class="form-control" placeholder="Digite o CPF:" v-mask-cpf
                  v-model="state.profissional.cpf.value" />
                <span v-if="state.profissional.cpf.error" class="text-danger">Este campo é obrigatório</span>
              </div>

              <div class="col-md-6">
                <label for="descricao">Descrição</label>
                <textarea id="descricao" type="text" class="form-control" placeholder="Digite uma descricão:"
                  v-model="state.profissional.descricao.value"></textarea>
                <span v-if="state.profissional.descricao.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-6">
                <label>Imagem</label>
                <input type="file" class="form-control" @change="adicionarImagem" />
                <span v-if="state.erro_imagem" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div style="display: flex" class="col-md-4" v-if="state.imagem.imagem">
                <img :src="state.imagem.imagem" class="imagem" />
                <button class="btn_deletar_imagem" @click="removerImagem">
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                    class="bi bi-x-lg mb-2" viewBox="0 0 16 16">
                    <path
                      d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <label for="endereco">Estado</label>
                <select class="form-select" v-model="state.profissional.estado_id"
                  @change="fetchCidade($event.target.value)">
                  <option :value="estado.id" v-for="estado in state.estados" :key="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="numero">Cidade</label>
                <select class="form-select" v-model="state.profissional.cidade_id.value">
                  <option :value="cidade.id" v-for="cidade in state.cidades" :key="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
                <span v-if="state.profissional.cidade_id.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-3">
                <label for="cep">CEP</label>
                <input class="form-control" v-model="state.profissional.cep.value" v-mask-cep />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="endereco">Endereço</label>
                <input id="endereco" type="text" class="form-control" v-model="state.profissional.endereco.value"
                  placeholder="Digite um endereço:" />
                <span v-if="state.profissional.endereco.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="endereco">Bairro</label>
                <input id="endereco" type="text" class="form-control" v-model="state.profissional.bairro.value"
                  placeholder="Digite um bairro:" />
                <span v-if="state.profissional.bairro.error" class="text-danger">Este campo é obrigatório</span>
              </div>
              <div class="col-md-2">
                <label for="numero">Número</label>
                <input id="numero" type="text" class="form-control" v-model="state.profissional.numero.value"
                  placeholder="Digite um número:" />
                <span v-if="state.profissional.numero.error" class="text-danger">Este campo é obrigatório</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarProfissional" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/profissionais">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      profissional: {
        id: "",
        nome: {
          value: "",
          error: false,
        },
        especialidade_id: {
          value: "",
          error: false,
        },
        email: {
          value: "",
          error: false,
        },
        valor_consulta: {
          value: "",
          error: false,
        },
        telefone: {
          value: "",
          error: false,
        },
        conselho: {
          value: "",
          error: false,
        },
        descricao: {
          value: "",
          error: false,
        },
        estado_id: "",
        cidade_id: {
          value: "",
          error: false,
        },
        endereco: {
          value: "",
          error: false,
        },
        bairro: {
          value: "",
          error: false,
        },
        numero: {
          value: "",
          error: false,
        },
        cep: {
          value: "",
          error: false,
        },
        cpf: {
          value: "",
          error: false,
        },
      },
      erro_imagem: false,
      imagem: {},
      especialidades: [],
      estados: [],
      cidades: [],
      planos: [],
      array_plano: [],
      plano_id: "",
    });
    onMounted(() => {
      fetchPlanos();
      fetchEspecialidades();
      fetchEstados();
      if (router.currentRoute._value.params.id != undefined) {
        fetcProfissional();
      }
    });
    async function fetcProfissional() {
      try {
        const { data } = await services.profissionais.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.profissional.nome.value = data.nome;
        state.profissional.especialidade_id.value = data.especialidade_id;
        state.profissional.destaque = data.destaque;
        state.profissional.email.value = data.email;
        state.profissional.cpf.value = data.cpf;
        state.profissional.valor_consulta.value = data.valor_consulta;
        state.profissional.telefone.value = data.telefone;
        state.profissional.endereco.value = data.endereco;
        state.profissional.bairro.value = data.bairro;
        state.profissional.numero.value = data.numero;
        state.profissional.estado_id = data.estado_id;
        state.profissional.id = data.id;
        state.profissional.cidade_id.value = data.cidade.id;
        state.profissional.cep.value = data.cep;
        state.profissional.descricao.value = data.descricao;
        state.profissional.conselho.value = data.conselho;
        state.imagem.imagem = data.imagem;

        fetchCidade(data.estado_id);
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEspecialidades() {
      try {
        const { data } = await services.especialidade.getAll({
          token,
        });
        console.log(data);
        state.especialidades = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchPlanos() {
      try {
        const { data } = await services.plano.getAll({
          token,
        });
        console.log(data);
        state.planos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function adicionarPlano() {
      // state.array_plano.push({});
      try {
        await services.profissionais.savePlano({
          profissional_id: state.profissional.id,
          plano_id: state.plano_id,
          token,
        });
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEspecialidade(especialidade_id) {
      try {
        const { data } = await services.especialidade.getById({
          id: especialidade_id,
          token,
        });
        console.log(data);
        state.especialidade = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEstados() {
      try {
        const { data } = await services.estado.getAll({
          token,
        });
        console.log(data);
        state.estados = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCidade(estado_id) {
      try {
        const { data } = await services.estado.getCidades({
          estado_id,
          token,
        });
        state.cidades = data.data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarProfissional() {
      var erro_validacao = false;

      if (state.profissional.nome.value.length == 0) {
        state.profissional.nome.error = true;
        erro_validacao = true;
      }
      if (state.profissional.especialidade_id.value.length == 0) {
        state.profissional.especialidade_id.error = true;
        erro_validacao = true;
      }
      if (state.profissional.conselho.value.length == 0) {
        state.profissional.conselho.error = true;
        erro_validacao = true;
      }
      if (state.profissional.valor_consulta.value.length == 0) {
        state.profissional.valor_consulta.error = true;
        erro_validacao = true;
      }
      if (state.profissional.telefone.value.length == 0) {
        state.profissional.telefone.error = true;
        erro_validacao = true;
      }
      if (state.profissional.descricao.value.length == 0) {
        state.profissional.descricao.error = true;
        erro_validacao = true;
      }
      if (state.imagem.imagem == null || state.imagem.imagem == undefined) {
        state.erro_imagem = true;
        erro_validacao = true;
      }

      if (state.profissional.cidade_id.value.length == 0) {
        state.profissional.cidade_id.error = true;
        erro_validacao = true;
      }
      if (state.profissional.endereco.value.length == 0) {
        state.profissional.endereco.error = true;
        erro_validacao = true;
      }
      if (state.profissional.bairro.value.length == 0) {
        state.profissional.bairro.error = true;
        erro_validacao = true;
      }
      if (state.profissional.numero.value.length == 0) {
        state.profissional.numero.error = true;
        erro_validacao = true;
      }
      if (state.profissional.cep.value.length == 0) {
        state.profissional.cep.error = true;
        erro_validacao = true;
      }
      if (state.profissional.cpf.value.length == 0) {
        state.profissional.cpf.error = true;
        erro_validacao = true;
      }

      if (state.destaque == "SIM") {
        if (state.profissional.email.value.length == 0) {
          state.profissional.email.error = true;
          erro_validacao = true;
        }
      }


      if (erro_validacao == true) {
        return;
      }

      let dados = new FormData();
      dados.append("nome", state.profissional.nome.value);
      var number = state.profissional.telefone.value;
      var clean = number.replace(/[^0-9,]*/g, "");
      state.profissional.telefone.value = clean;
      dados.append("telefone", state.profissional.telefone.value);
      dados.append(
        "especialidade_id",
        state.profissional.especialidade_id.value
      );
      dados.append("valor_consulta", state.profissional.valor_consulta.value);
      dados.append("conselho", state.profissional.conselho.value);
      dados.append("destaque", state.profissional.destaque);
      dados.append("email", state.profissional.email.value);
      dados.append("cpf", state.profissional.cpf.value);
      dados.append("descricao", state.profissional.descricao.value);
      dados.append("cidade_id", state.profissional.cidade_id.value);
      dados.append("cep", state.profissional.cep.value);
      dados.append("endereco", state.profissional.endereco.value);
      dados.append("numero", state.profissional.numero.value);
      dados.append("bairro", state.profissional.bairro.value);

      dados.append("forma_pagamento", state.profissional.forma_pagamento);
      dados.append("holder_name", state.profissional.holder_name);
      dados.append("number", state.profissional.number);
      dados.append("cvv", state.profissional.cvv);
      dados.append("exp_month", state.profissional.exp_month);
      dados.append("exp_year", state.profissional.exp_year);


      if (state.imagem.file != null && state.imagem.file != undefined) {
        dados.append("imagem", state.imagem.file);
      }
      if (!state.profissional.id) {
        await services.profissionais
          .save({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Profissionais" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        dados.append("id", state.profissional.id);
        dados.append("_method", "PATCH");
        if (state.imagem.file != undefined) {
          try {
            await services.profissionais.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        await services.profissionais
          .update({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Profissionais" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];
      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarProfissional,
      router,
      state,
      fetchCidade,
      fetchEspecialidade,
      adicionarPlano,
      adicionarImagem,
      removerImagem,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.imagem {
  width: 200px;
  height: 200px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
  border-radius: 100%;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>